import React, { useState } from 'react';
import InstallAppMenuItem from '../components/InstallAppMenuItem';
import { EXTENSION_STORE_URL } from '../services/ExtensionDetectionService';
import { BUILD_TIMESTAMP } from '../timestamp';

function Sidebar({ p_roles, onClose, onLogout, p_sharedLists, p_isProprio, onOpenSharedList, onRemoveSharedList }) {
  const [isSharedOpen, setIsSharedOpen] = useState(false);
  const [openOwners, setOpenOwners] = useState({});
  const groupedSharedLists = (p_sharedLists || []).reduce((acc, entry) => {
    const ownerLabel = entry.ownerName || entry.ownerKey || "Proprietaire";
    if (!acc[ownerLabel]) acc[ownerLabel] = [];
    acc[ownerLabel].push(entry);
    return acc;
  }, {});

  return (
    <div style={{ position: 'fixed', inset: 0, zIndex: 2000, background: 'rgba(0,0,0,0.35)' }} onClick={onClose}>
      <div
        style={{
          position: 'absolute', top: 0, right: 0, bottom: 0,
          width: 300, maxWidth: '90vw',
          background: '#fff',
          display: 'flex', flexDirection: 'column',
          animation: 'slideInRight 0.25s ease',
          boxShadow: '-4px 0 24px rgba(0,0,0,0.12)',
        }}
        onClick={e => e.stopPropagation()}
      >
        {/* Header */}
        <div style={{
          background: 'linear-gradient(135deg, #1c4e8f, #2563EB)',
          padding: '52px 20px 24px',
          flexShrink: 0,
          position: 'relative',
        }}>
          <button
            onClick={onClose}
            aria-label="Fermer le menu"
            style={{
              position: 'absolute', top: 16, right: 16,
              background: 'rgba(255,255,255,0.15)', border: 'none',
              borderRadius: '50%', width: 36, height: 36,
              color: '#fff', fontSize: 20, cursor: 'pointer',
              display: 'flex', alignItems: 'center', justifyContent: 'center',
            }}
          >×</button>
          <div style={{ fontSize: 13, fontWeight: 600, color: 'rgba(255,255,255,0.75)', marginBottom: 4 }}>Mon compte</div>
          <div style={{ fontSize: 20, fontWeight: 800, color: '#fff' }}>Listaki</div>
        </div>

        {/* Nav items */}
        <div style={{ flex: 1, overflowY: 'auto', padding: '12px 0' }}>
          <InstallAppMenuItem />

          <SidebarItem
            icon={<svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2"><rect x="3" y="3" width="7" height="7"/><rect x="14" y="3" width="7" height="7"/><rect x="14" y="14" width="7" height="7"/><rect x="3" y="14" width="7" height="7"/></svg>}
            label="Installer l'extension"
            href={EXTENSION_STORE_URL}
            target="_blank"
            onClick={() => { if (window.umami) window.umami.track('menu-InstallExtension'); }}
          />
          <SidebarItem
            icon={<svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2"><circle cx="12" cy="12" r="10"/><path d="M12 16v-4M12 8h.01"/></svg>}
            label="Aide"
            href="https://listaki.fr/aide"
            target="_blank"
          />
          <SidebarItem
            icon={<svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2"><path d="M12 2L15.09 8.26L22 9.27L17 14.14L18.18 21.02L12 17.77L5.82 21.02L7 14.14L2 9.27L8.91 8.26L12 2z"/></svg>}
            label="Nouveautés"
            href="https://listaki.fr/changelog"
            target="_blank"
          />
          <SidebarItem
            icon={<svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2"><path d="M4 4h16a2 2 0 0 1 2 2v12a2 2 0 0 1-2 2H4a2 2 0 0 1-2-2V6a2 2 0 0 1 2-2z"/><polyline points="22 6 12 13 2 6"/></svg>}
            label="Contact"
            href="https://listaki.fr/contact/"
            target="_blank"
            onClick={() => { if (window.umami) window.umami.track('menu-Contact'); }}
          />

          {p_isProprio && p_sharedLists && p_sharedLists.length > 0 && (
            <div style={{ borderTop: '1px solid #F3F4F6', margin: '8px 0' }}>
              <button
                type="button"
                style={{
                  display: 'flex', alignItems: 'center', gap: 12,
                  width: '100%', padding: '12px 20px',
                  background: 'none', border: 'none', cursor: 'pointer',
                  fontSize: 14, fontWeight: 600, color: '#374151',
                  textAlign: 'left',
                }}
                onClick={() => setIsSharedOpen(prev => !prev)}
              >
                <span style={{ color: '#6B7280' }}>
                  <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2"><path d="M4 12v8a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2v-8"/><polyline points="16 6 12 2 8 6"/><line x1="12" y1="2" x2="12" y2="15"/></svg>
                </span>
                Listes mémorisées
                <span style={{ marginLeft: 'auto', fontSize: 12, color: '#9CA3AF' }}>{isSharedOpen ? '▲' : '▼'}</span>
              </button>
              {isSharedOpen && (
                <div style={{ paddingBottom: 4 }}>
                  {Object.entries(groupedSharedLists).map(([ownerLabel, entries]) => {
                    const isOwnerOpen = Boolean(openOwners[ownerLabel]);
                    return (
                      <div key={ownerLabel}>
                        <button
                          type="button"
                          style={{
                            display: 'flex', alignItems: 'center',
                            width: '100%', padding: '8px 20px 8px 50px',
                            background: 'none', border: 'none', cursor: 'pointer',
                            fontSize: 13, fontWeight: 600, color: '#6B7280',
                            textAlign: 'left', gap: 6,
                          }}
                          onClick={() => setOpenOwners(prev => ({ ...prev, [ownerLabel]: !isOwnerOpen }))}
                        >
                          {isOwnerOpen ? '▾' : '▸'} {ownerLabel}
                        </button>
                        {isOwnerOpen && entries.map(entry => (
                          <div key={`${entry.key}-${entry.idList}`}
                            style={{ display: 'flex', alignItems: 'center', padding: '6px 16px 6px 60px', gap: 4 }}
                          >
                            <button
                              style={{ flex: 1, background: 'none', border: 'none', cursor: 'pointer', fontSize: 13, color: '#2563EB', textAlign: 'left', padding: '2px 0' }}
                              onClick={() => onOpenSharedList && onOpenSharedList(entry)}
                            >
                              {entry.name || `Liste ${entry.idList}`}
                            </button>
                            <button
                              style={{ background: 'none', border: 'none', cursor: 'pointer', color: '#EF4444', fontSize: 11, padding: '2px 4px' }}
                              onClick={() => onRemoveSharedList && onRemoveSharedList(entry)}
                              title="Retirer"
                            >✕</button>
                          </div>
                        ))}
                      </div>
                    );
                  })}
                </div>
              )}
            </div>
          )}

          {p_roles && p_roles.includes('ADMIN') && (
            <div style={{ borderTop: '1px solid #F3F4F6', margin: '8px 0' }}>
              <div style={{ padding: '8px 20px', fontSize: 11, fontWeight: 700, color: '#9CA3AF', textTransform: 'uppercase', letterSpacing: 1 }}>Admin</div>
              <SidebarItem
                icon={<svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2"><line x1="18" y1="20" x2="18" y2="10"/><line x1="12" y1="20" x2="12" y2="4"/><line x1="6" y1="20" x2="6" y2="14"/></svg>}
                label="Statistiques"
                href="/stats"
              />
              <SidebarItem
                icon={<svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2"><path d="M14 2H6a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V8z"/><polyline points="14 2 14 8 20 8"/></svg>}
                label="Rapport détaillé"
                href="/report"
              />
            </div>
          )}
        </div>

        {/* Footer: logout */}
        <div style={{ padding: '12px 20px 28px', borderTop: '1px solid #F3F4F6', flexShrink: 0 }}>
          <button
            onClick={onLogout}
            style={{
              display: 'flex', alignItems: 'center', gap: 12,
              width: '100%', padding: '11px 16px',
              background: '#FEF2F2', border: '1.5px solid #FECACA',
              borderRadius: 12, cursor: 'pointer',
              fontSize: 14, fontWeight: 600, color: '#DC2626',
              fontFamily: 'inherit',
            }}
          >
            <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" aria-hidden="true"><path d="M9 21H5a2 2 0 0 1-2-2V5a2 2 0 0 1 2-2h4"/><polyline points="16 17 21 12 16 7"/><line x1="21" y1="12" x2="9" y2="12"/></svg>
            Se déconnecter
          </button>
          <div style={{ display: 'flex', justifyContent: 'center', gap: 16, marginTop: 14, fontSize: 12 }}>
            <a href="https://listaki.fr/cgu/" target="_blank" rel="noopener noreferrer" style={{ color: '#6B7280', textDecoration: 'none' }}>CGU</a>
            <a href="https://listaki.fr/politique-confidentialite/" target="_blank" rel="noopener noreferrer" style={{ color: '#6B7280', textDecoration: 'none' }}>Confidentialité</a>
          </div>
          <div style={{ textAlign: 'center', marginTop: 6, fontSize: 11, color: '#9CA3AF' }}>Version: Beta {BUILD_TIMESTAMP}</div>
        </div>
      </div>
    </div>
  );
}

function SidebarItem({ icon, label, href, target, onClick }) {
  return (
    <a
      href={href}
      target={target}
      rel={target === '_blank' ? 'noopener noreferrer' : undefined}
      onClick={onClick}
      style={{
        display: 'flex', alignItems: 'center', gap: 12,
        padding: '12px 20px',
        fontSize: 14, fontWeight: 500, color: '#374151',
        textDecoration: 'none',
        transition: 'background 0.12s',
      }}
      onMouseEnter={e => e.currentTarget.style.background = '#F9FAFB'}
      onMouseLeave={e => e.currentTarget.style.background = 'transparent'}
    >
      <span style={{ color: '#6B7280', display: 'flex', flexShrink: 0 }}>{icon}</span>
      {label}
    </a>
  );
}

export default Sidebar;
